var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { EmptyState, FlexBox } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import styles from './contactsEmptyState.module.scss';
/** Component that is used to show empty states in the context of contacts */
export function ContactsEmptyState(_a) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return (_jsx(FlexBox, Object.assign({ width: "100%", height: "100%", alignItems: "center" }, { children: _jsx(EmptyState, Object.assign({}, rest, { className: classnames(className, styles.emptyState) })) })));
}
